<script>
import axios from 'axios';

import MiunFavourites from './MiunFavourites.vue';
import MiunMenu from './MiunMenu.vue';

//Async components
import { defineAsyncComponent } from 'vue';
const FavouritePopup = defineAsyncComponent(() =>
  import(/* webpackChunkName: "favouritesPopup" */ './FavouritePopup.vue')
);
const MenuPopup = defineAsyncComponent(() =>
  import(/* webpackChunkName: "menuPopup" */ './MenuPopup.vue')
);
const LangPopup = defineAsyncComponent(() =>
  import(/* webpackChunkName: "langPopup" */ './LangPopup.vue')
);
const Breadcrumbs = defineAsyncComponent(() =>
  import(/* webpackChunkName: "breadcrumbs" */ './Breadcrumbs.vue')
);
const LadokInformationModal = defineAsyncComponent(() =>
  import(/* webpackChunkName: "ladokInformationModal" */ './LadokInformationModal.vue')
);

export default {
  components: {
    MiunFavourites,
    MiunMenu,
    Breadcrumbs,
    FavouritePopup,
    LangPopup,
    MenuPopup,
    LadokInformationModal,
  },
  props: [
    'NoBreadCrumbs',
    'breadcrumbItems',
    'fetchMenuUrl',
    'pageId',
    'querySearchUrl',
    'subsite',
    'subsiteBackUrl',
    'componentStrings',
    'subsiteBackText',
    'subsiteTitle',
    'subsiteRootUrl',
    'subsiteRootTitle',
    'subsitePageId',
    'json',
    'staticSearchUrl',
    'skipLinkUrl',
    'skipLinkText',
    'subsiteStartUrl',
    'ladokInfoModal',
  ],
  data() {
    return {
      scrolled: false,
      breadcrumbs: false,
      data: this.json ? this.json : false,
      fLinktext: this.componentStrings?.favoritesText?.linkText || '',
      fOpentext: this.componentStrings?.favoritesText?.openFavorites || '',
      fClosetext: this.componentStrings?.favoritesText?.closeFavorites || '',
      fRemovetext: this.componentStrings?.favoritesText?.removeFavorites || '',
      menuUrl: this.fetchMenuUrl,
      originalpId: this.pageId,
      pId: this.pageId,
      addRemoveToolLtext: this.componentStrings?.AddRemoveTool?.linkText || '',
      addRemoveToolLurl: this.componentStrings?.AddRemoveTool?.linkUrl || '',
      addRemoveToolLicon: this.componentStrings?.AddRemoveTool?.linkIcon || '',
      addRemoveToolLcustomclass:
        this.componentStrings?.AddRemoveTool?.linkCustomClass || '',
      enableMenuWithouthBreadcrumbs: false,
      menus: [],
      scrolledDown: false,
      menuLoading: false,
      popups: {
        showFavouritePopup: false,
        showLangPopup: false,
        showMenu: false,
        showSearch: false,
        showTools: false,
        showUser: false,
        showLogin: false,
      },
      subsiteObj: {},
      goBackText: this.componentStrings?.menu?.goBackText || '',
      goBackMainMenuText: this.componentStrings?.menu?.goBackMainMenuText || '',
      colorTheme: false,
      ladokData: this.ladokInfoModal,
    };
  },
  created() {
    this.fetchMenuItemsOnLoad(this.menuUrl, this.pId, this.originalpId);
    window.addEventListener('scroll', this.handleScroll);
    this.isSubsite();
  },
  mounted() {
    let appContainer = document.getElementById('app');
    if (appContainer) {
      if (appContainer.classList.contains('header-min-height')) {
        appContainer.classList.remove('header-min-height');
      }
    }
    this.ifBreadcrumbsDontExist();
  },
  methods: {
    isSubsite() {
      if (
        this.subsite &&
        this.subsiteBackUrl &&
        this.subsiteBackText &&
        this.subsiteTitle
      ) {
        this.subsiteObj.subsite = this.subsite;
        this.subsiteObj.subsiteRootUrl = this.subsiteRootUrl;
        this.subsiteObj.subsiteRootTitle = this.subsiteRootTitle;
        this.subsiteObj.subsiteBackUrl = this.subsiteBackUrl;
        this.subsiteObj.subsiteBackText = this.subsiteBackText;
        this.subsiteObj.subsiteTitle = this.subsiteTitle;
        this.subsiteObj.subsitePageId = this.subsitePageId;
      }
    },
    ifBreadcrumbsDontExist() {
      if (this.NoBreadCrumbs || !this.breadcrumbItems) {
        let foldOutSearch = document.querySelector('.fold-out-search') || false;
        if (foldOutSearch) {
          let headerHeight = document.getElementById('app').offsetHeight;
          foldOutSearch.style.paddingTop = `${headerHeight}px`;
          this.enableMenuWithouthBreadcrumbs = true;
        }
      } else {
        let breadcrumbSettings = {
          breadcrumbItems: this.breadcrumbItems ? this.breadcrumbItems : false,
        };
        this.breadcrumbs = this.breadcrumbItems ? breadcrumbSettings : false;
      }
    },
    handleScroll() {
      if (this.scrolled) {
        this.hideAllPopups();
      }
      if (window.scrollY > 162 && this.enableMenuWithouthBreadcrumbs) {
        this.scrolledDown = true;
      } else {
        this.scrolledDown = false;
      }

      this.scrolled = window.scrollY > 162;
    },
    hideAllPopups(dontHideThisPopup) {
      Object.keys(this.popups).forEach((k) => {
        if (k !== dontHideThisPopup) {
          this.popups[k] = false;
        }
      });
    },
    toggleFavBox() {
      this.popups.showFavouritePopup = !this.popups.showFavouritePopup;
      this.shouldPageScroll(this.popups.showFavouritePopup);
      // Hide All Popups Except showFavouritePopup
      this.hideAllPopups('showFavouritePopup');
    },
    toggleLangBox() {
      this.popups.showLangPopup = !this.popups.showLangPopup;
      this.shouldPageScroll(this.popups.showLangPopup);
      // Hide All Popups Except showLangPopup
      this.hideAllPopups('showLangPopup');
    },
    toggleTools() {
      this.popups.showTools = !this.popups.showTools;
      this.shouldPageScroll(this.popups.showTools);
      // Hide All Popups Except showTools
      this.hideAllPopups('showTools');
    },
    toggleMenu() {
      this.popups.showMenu = !this.popups.showMenu;
      this.shouldPageScroll(this.popups.showMenu);
      // Hide All Popups Except showMenu
      this.hideAllPopups('showMenu');
    },
    toggleSearch() {
      this.popups.showSearch = !this.popups.showSearch;
      this.shouldPageScroll(this.popups.showSearch);
      // Hide All Popups Except showSearch
      this.hideAllPopups('showSearch');
    },
    toggleUser() {
      this.popups.showUser = !this.popups.showUser;
      this.shouldPageScroll(this.popups.showUser);
      // Hide All Popups Except showUser
      this.hideAllPopups('showUser');
    },
    toggleLogin() {
      this.popups.showLogin = !this.popups.showLogin;
      this.shouldPageScroll(this.popups.showLogin);
      // Hide All Popups Except showLogin
      this.hideAllPopups('showLogin');
    },
    shouldPageScroll(bool) {
      let body = document.getElementsByTagName('body')[0];
      if (bool) {
        body.style.overflow = 'hidden';
      } else {
        body.style.overflow = null;
      }
    },
    async fetchMenuItemsOnLoad(url, pageID, originalPageID) {
      try {
        this.menuLoading = true;
        const res = await axios.post(url, {
          id: pageID,
          originalpId: originalPageID,
        });
        const menus = res.data;
        if (menus) {
          this.menus = menus;
        }
        this.menuLoading = false;
      } catch (error) {
        this.menuLoading = false;
      }
    },
    forwardEmit(colorTheme) {
      this.colorTheme = colorTheme;
    },
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>
<template>
  <div
    class="miun-header"
    id="miun-header"
    :class="[
      enableMenuWithouthBreadcrumbs ? 'no-breadcrumbs' : '',
      scrolled ? 'sticky-scroll' : '',
    ]">
    <header
      class="miun-menu__wrapper"
      v-if="data"
      :class="[scrolledDown ? 'hide-menu' : '']">
      <a :href="skipLinkUrl" class="skip-link">{{ skipLinkText }}</a>
      <MiunFavourites
        :quicklinks="data.quicklinks"
        :favoriteActive="popups.showFavouritePopup"
        @show-fav-box="toggleFavBox"
        :langActive="popups.showLangPopup"
        @show-lang-box="toggleLangBox"
        @color-theme-changed="forwardEmit"
        :fOpentext="fOpentext"
        :fLinktext="fLinktext"
        :cartUrl="data.cartUrl"
        :language="data.languageLinks"
        :lattlast="data.lattlast" />
      <MiunMenu
        :addToolLinktext="addRemoveToolLtext"
        :addToolLinkurl="addRemoveToolLurl"
        :addToolLinkicon="addRemoveToolLicon"
        :addToolLinkclass="addRemoveToolLcustomclass"
        :staticSearchUrl="staticSearchUrl"
        :isLoggedIn="data.isLoggedIn"
        :menuText="data.menuButton"
        :loginButton="data.loginLink"
        :menuButton="data.menuButton"
        :toolsButton="data.toolsButton"
        :searchButton="data.searchButton"
        :newsNotification="data.newsNotification"
        :userButton="data.userButton"
        :user="data.userNav"
        :tools="data.toolsNav"
        :logo="data.logo"
        @show-user="toggleUser"
        @show-login="toggleLogin"
        @show-tools="toggleTools"
        @show-search="toggleSearch"
        @show-menu="toggleMenu"
        :color-theme="colorTheme"
        :showMenuState="popups.showMenu"
        :toolsActive="popups.showTools"
        :userActive="popups.showUser"
        :loginActive="popups.showLogin" />
      <div class="divider" />
      <Breadcrumbs
        :class="{ sticky: scrolled }"
        :breadcrumbs="breadcrumbs"
        v-if="breadcrumbs && !NoBreadCrumbs" />
      <div
        id="breadcrumbplaceholder"
        class="sticky-placeholder"
        v-if="breadcrumbs && !NoBreadCrumbs"></div>
    </header>

    <transition name="fade" mode="out-in">
      <template v-if="popups.showFavouritePopup">
        <FavouritePopup
          @hide-favourite-popup="toggleFavBox"
          :fRemovetext="fRemovetext" />
      </template>
    </transition>
    <transition name="fade" mode="out-in">
      <LangPopup
        @hide-lang-popup="toggleLangBox"
        v-if="popups.showLangPopup"
        :fRemovetext="fRemovetext"
        :language="data.languageLink"
        :languageSv="data.languageLinkSv"
        :LanguagePages="data.LanguagePages" />
    </transition>
    <LadokInformationModal v-if="ladokData" :data="ladokData" />
    <MenuPopup
      :subsite="subsiteObj"
      :goBack="goBackText"
      :goBackMainMenu="goBackMainMenuText"
      :menu="menus"
      :menuLoading="menuLoading"
      :url="menuUrl"
      :pageID="pId"
      :originalPageID="originalpId"
      v-if="popups.showMenu"
      @hide-menu="toggleMenu" />
    <transition name="fade" mode="out-in">
      <div v-if="popups.showTools" @click="toggleTools" class="dim-bg"></div>
    </transition>
    <transition name="fade" mode="out-in">
      <div v-if="popups.showUser" @click="toggleUser" class="dim-bg"></div>
    </transition>
    <transition name="fade" mode="out-in">
      <div v-if="popups.showLogin" @click="toggleLogin" class="dim-bg"></div>
    </transition>
  </div>
</template>
